import { MASCOT_URL } from '../assets/mascot';

export const MascotLoader = ({ text = 'Chargement...', fullScreen = true }) => {
  return (
    <div
      className={`${fullScreen ? 'min-h-screen' : 'py-16'} w-full flex flex-col items-center justify-center bg-[#F8F9FA]`}
      data-testid="mascot-loader"
    >
      <div className="relative flex items-center justify-center">
        <div className="absolute w-40 h-40 rounded-full bg-[#8B7355]/15 mascot-pulse" />
        <img src={MASCOT_URL} alt="KARDIF" className="relative w-28 h-auto drop-shadow-xl mascot-float" />
      </div>
      <div className="mt-6 flex items-center gap-2 text-[#8B7355]">
        <span className="w-2 h-2 rounded-full bg-[#8B7355] mascot-dot" style={{ animationDelay: '0ms' }} />
        <span className="w-2 h-2 rounded-full bg-[#8B7355] mascot-dot" style={{ animationDelay: '150ms' }} />
        <span className="w-2 h-2 rounded-full bg-[#8B7355] mascot-dot" style={{ animationDelay: '300ms' }} />
      </div>
      <p className="mt-3 text-sm font-medium text-[#6B7280]">{text}</p>
    </div>
  );
};

export default MascotLoader;
